module.exports = __webpack_public_path__ + "Montserrat-Medium-5f797490f806b3b229299f0a66de89c9.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/montserrat/Montserrat-Medium.ttf
// module id = 875
// module chunks = 86